import React, { Component } from "react";
import Carousel from "react-bootstrap/Carousel";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import firebase from "firebase";
class MainCarousel extends Component {
  constructor() {
    super();
    this.state = { carousels: [] };
    this.getCarousels();
  }
  render() {
    return (
      <div>
        <Carousel>
          {this.state.carousels.map(carousel => (
            <Carousel.Item align="center">
              <img
                style={{ height: "100%", width: "100%", align: "center" }}
                className="d-block mt-3 w-100"
                src={carousel.imgUrl}
                alt="First slide"
              />
              <Carousel.Caption>
                <h3>{carousel.title}</h3>
                <p>{carousel.text}</p>
                {carousel.androidUrl !== "" ? (
                  <a href={carousel.androidUrl} target="blank">
                    <Image
                      rounded
                      src="\images\googlePlayDownload.jpg"
                      className=" "
                      alt="Google Play"
                      style={{ margin: "0px", width: "30%", maxWidth: "150px" }}
                    ></Image>{" "}
                  </a>
                ) : (
                  ""
                )}
                {carousel.iosUrl !== "" ? (
                  <a href={carousel.iosUrl} target="blank">
                    <Image
                      rounded
                      src="\images\appStoreDownload.jpg"
                      className=" "
                      alt="App Store"
                      style={{ margin: "0px", width: "30%", maxWidth: "150px" }}
                    ></Image>
                  </a>
                ) : (
                  ""
                )}
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    );
  }

  getCarousels = () => {
    var self = this;
    firebase
      .database()
      .ref("/Carousels/")
      .on("value", function(snapshot) {
        snapshot.forEach(function(item) {
          self.setState({ carousels: [...self.state.carousels, item.val()] });
        });
        console.log(self.state.carousels);
      });
  };
}

export default MainCarousel;
